<script lang="ts" setup>
import { ref, onMounted, reactive, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { useLocaleStore } from '../../stores/locale';
import axiosApiClient from '@/axios';
import projectYpes from '@/data/projectTypes.ts';
import Calculator from '@/components/shared/Calculator.vue';

const isbusy = ref(false);
const t = useI18n().t;
const localeStore = useLocaleStore();
const swal = inject('$swal') as any;
interface Configuration {
  key: string;
  value: string;
}

const configurations = ref<Configuration[]>([]);
onMounted(async () => {
  configurations.value = [{
    key: 'interior_design',
    value: '0',
  }, {
    key: 'finished_projects',
    value: '0',
  }, {
    key: 'expert_designer',
    value: '0', 
  }];
  statsConfig().then(() => {
    // Fetch configurations from localStorage if available   
    setTimeout(() => {
      const count = document.querySelectorAll('.count-style h2');
      count.forEach(el => {
        const max = el.getAttribute('data-max') || '0';
        let i = 0;
        const interval = setInterval(() => {
          if (i < parseInt(max, 10)) {
            el.innerHTML = i.toString();
            i++;
          } else {
            clearInterval(interval);
          }
        }, 1000 / parseInt(max));
      });
    }, 200);
    isbusy.value = false;
  }).catch(() => {
   console.log('Error fetching configurations');
    isbusy.value = false;
  });

});
const form = reactive({
  name: '',
  email: '',
  phone: '',
  message: '',
  honeypot: '',
  real_estate_type: '',
  project_type: '',
});
const sendContactusEmail = async () => {
  //call axios api
  isbusy.value = true;
  var response = await axiosApiClient.post('/api/contact-us', {
    name: form.name,
    email: form.email,
    phone: form.phone,
    message: form.message,
    honeypot: form.honeypot,
    real_estate_type: form.real_estate_type,
    project_type: form.project_type,
  });
  if (response.data.status == 'success') {
    form.name = '';
    form.email = '';
    form.phone = '';
    form.message = '';
    form.honeypot = '';
    swal
      .fire({
        icon: 'success',
        title: 'Your message has been sent successfully',
        showConfirmButton: false,
        timer: 1500,
      })
      .then(() => {
        isbusy.value = false;
      });
  } else {
    swal
      .fire({
        icon: 'error',
        title: 'Something went wrong. Please try again.',
        showConfirmButton: false,
        timer: 1500,
      })
      .then(() => {
        isbusy.value = false;
      });
  }
};

const statsConfig = async () => {
  //call axios api
  isbusy.value = true;
  var response = await axiosApiClient.get('/api/configurations/stats');
  if (response.status == 200) {
    configurations.value = response.data;
  }
};

</script>
<template>
  <section id="estimation-calculator" class="pt-3 my-2" style="background: url('/assets/img/calc-bg.png'); padding-block: 5px;border-radius: 10px;opacity:calc(0.9);">
    <div class="container mx-auto max-w-5xl">
      <div class="heading two" :class="localeStore.locale == 'ar' ? 'text-end' : 'text-start'"
        :dir="localeStore.locale == 'ar' ? 'rtl' : 'ltr'">
        <!-- <span>{{ t('Estimation Calculator') }}</span> -->
        <h2>{{ t('Construction Estimation Calculator') }}</h2>
      </div>
      <!--Calculator-->
      <Calculator />
    </div>
  </section>
  <section id="design-your" class="design-your gap"
    style="background-image: url(../../../../../assets/img/design-your.jpg)">
    <div class="container">
      <div class="row">
        <div class="col-lg-7">
          <div class="heading two" :class="localeStore.locale == 'ar' ? 'text-end' : 'text-start'"
            :dir="localeStore.locale == 'ar' ? 'rtl' : 'ltr'">
            <span>{{ t('We designed your space') }}</span>
            <h2>{{ t('Interesting Facts About Construction industry') }}</h2>
          </div>
          <div class="count-number">
            <div class="count-style">
              <i class="flaticon-customer-service"></i>
              <h2 :data-max="configurations.filter(k => k.key == 'interior_design')[0]
                  ?.value || 0
                ">
                <sup>k</sup>
              </h2>
              <p>{{ t('house interior design') }}</p>
            </div>
            <div class="count-style">
              <i class="flaticon-architecture"></i>
              <h2 :data-max="configurations.filter(k => k.key == 'finished_projects')[0]
                  ?.value || 0
                ">
                <sup>m</sup>
              </h2>
              <p>{{ t('finished projects') }}</p>
            </div>
            <div class="count-style">
              <i class="flaticon-engineer"></i>
              <h2 :data-max="configurations.filter(k => k.key == 'expert_designer')[0]
                  ?.value || 0
                ">
                <sup>+</sup>
              </h2>
              <p>{{ t('expert designer') }}</p>
            </div>
          </div>
        </div>
        <div class="col-lg-5" :class="localeStore.locale == 'ar' ? 'text-end' : 'text-start'"
          :dir="localeStore.locale == 'ar' ? 'rtl' : 'ltr'">
          <form class="meet-experts" @submit.prevent="sendContactusEmail">
            <h2>{{ t('Request a Quote') }}!</h2>
            <p>{{ t('have any question feel free to contact us') }}.</p>
            <div class="flex gap-3 py-2">
              <div class="flex flex-col flex-grow">
                <label for="real_estate_type" class="text-white">
                  {{ t('Real Estate Type') }}
                </label>
                <select name="real_estate_type" id="real_estate_type" class="form-select" v-model="form.real_estate_type" required>
                  <option value="">{{ t('Select Type') }}</option>
                  <option value="villas">{{ t('Villas') }}</option>
                  <option value="buildings">{{ t('Buildings') }}</option>
                </select>
              </div>
              <div class="flex flex-col flex-grow">
                <label for="project_type" class="text-white">{{ t('Project Type') }}</label>
                <select name="" id="project_type" class="form-select" v-model="form.project_type" required>
                  <option value="">{{ t('Select Type') }}</option>
                  <option v-for="type in projectYpes" :key="type" value="type">
                    {{ t(type) }}
                  </option>
                </select>
              </div>
            </div>
            <input type="text" class="form-control" v-model="form.name" name="complete name"
              :placeholder="t('complete name')" required />
            <input type="email" class="form-control" v-model="form.email" name="email address"
              :placeholder="t('email address')" required />
            <input type="text" class="form-control" v-model="form.phone" name="phone no"
              :placeholder="t('phone number')" required />
            <textarea class="form-control" v-model="form.message" :placeholder="t('message')" required></textarea>
            <div style="display: none">
              <input type="text" name="honeypot" v-model="form.honeypot" />
            </div>
            <button class="theme-btn" :disabled="isbusy">
              {{ isbusy ? t('Sending...') : t('Submit Now') }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped></style>
